import { Link, useLocation } from "wouter";
import Icon from "./Icon";
import { useStoreQuery, queries } from "@/lib/store";

const items = [
  { href: "/",          label: "Today",    icon: "wb_sunny" },
  { href: "/garden",    label: "Garden",   icon: "yard" },
  { href: "/move",      label: "Move",     icon: "fitness_center" },
  { href: "/nourish",   label: "Nourish",  icon: "restaurant" },
  { href: "/gather",    label: "Gather",   icon: "diversity_3" },
  { href: "/flourish",  label: "Flourish", icon: "menu_book" },
];

export default function BottomNav() {
  const [location] = useLocation();
  const liveCount = useStoreQuery(() => queries.liveNow().length);
  const me = useStoreQuery(queries.currentUser);
  // No fallback to the seeded demo account: without it, an unresolved identity showed the
  // seeded demo account's training day as a badge on this sister's nav.
  const trainingToday = useStoreQuery(() =>
    me?.id ? queries.todaysSession(me.id, new Date().toISOString()) : null,
  );
  return (
    <nav
      aria-label="Primary"
      className="absolute bottom-0 inset-x-0 z-30"
      style={{
        background: "rgba(245,240,232,0.92)",
        backdropFilter: "blur(14px)",
        WebkitBackdropFilter: "blur(14px)",
        borderTop: "1px solid rgba(30,74,53,0.08)",
        paddingBottom: "max(8px, env(safe-area-inset-bottom))",
      }}
    >
      <div className="flex items-stretch justify-between px-1 py-1.5">
        {items.map((it) => {
          const active = location === it.href;
          return (
            <Link
              key={it.href}
              href={it.href}
              data-testid={`nav-${it.label.toLowerCase()}`}
              className="flex-1 flex flex-col items-center gap-0.5 py-1 rounded-2xl no-underline transition-colors"
              style={{ color: active ? "var(--mnf-f)" : "var(--mnf-tg)", minWidth: 0 }}
            >
              <span
                className="flex items-center justify-center transition-all"
                style={{
                  width: 38,
                  height: 26,
                  borderRadius: 13,
                  background: active ? "rgba(30,74,53,0.10)" : "transparent",
                  position: "relative",
                }}
              >
                <Icon name={it.icon} filled={active} size={20} weight={active ? 500 : 400} />
                {it.href === "/gather" && liveCount > 0 && (
                  <span
                    aria-label="Live now"
                    className="mnf-live-dot"
                    style={{
                      position: "absolute",
                      top: 1,
                      right: 6,
                      width: 7,
                      height: 7,
                      borderRadius: "50%",
                      background: "var(--mnf-c)",
                      boxShadow: "0 0 0 2px rgba(245,240,232,0.92)",
                    }}
                  />
                )}
                {it.href === "/move" && trainingToday && (
                  <span
                    aria-label="Training day"
                    style={{
                      position: "absolute",
                      top: 1,
                      right: 6,
                      width: 7,
                      height: 7,
                      borderRadius: "50%",
                      background: "var(--mnf-fiberBorder)",
                      boxShadow: "0 0 0 2px rgba(245,240,232,0.92)",
                    }}
                  />
                )}
              </span>
              <span
                className="font-sans"
                style={{
                  fontSize: 9.5,
                  fontWeight: active ? 700 : 500,
                  letterSpacing: "0.03em",
                  textTransform: "uppercase",
                }}
              >
                {it.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
